import { render, staticRenderFns } from "./CategoriaDeArvore.vue?vue&type=template&id=5419030a&scoped=true"
import script from "./CategoriaDeArvore.vue?vue&type=script&lang=js"
export * from "./CategoriaDeArvore.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=5419030a&prod&scoped=true&lang=css&external"
import style1 from "./CategoriaDeArvore.vue?vue&type=style&index=1&id=5419030a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5419030a",
  null
  
)

export default component.exports